module.exports = __webpack_public_path__ + "static/media/qingjia.bfee991a.png";